(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4789],{

/***/ 34789:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Content084": function() { return /* binding */ Content084; },
  "default": function() { return /* binding */ Content084_Content084; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/shared/components/index.js + 115 modules
var components = __webpack_require__(87900);
// EXTERNAL MODULE: ./src/shared/components/Tabs/Tabs.Provider.js
var Tabs_Provider = __webpack_require__(11742);
// EXTERNAL MODULE: ./src/components/widgets/content/Content084/Content084.module.scss
var Content084_module = __webpack_require__(66406);
var Content084_module_default = /*#__PURE__*/__webpack_require__.n(Content084_module);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./src/shared/components/Tabs/Tabs.hooks.js
var Tabs_hooks = __webpack_require__(60419);
// EXTERNAL MODULE: ./src/components/widgets/content/Content084/Items/Items.module.scss
var Items_module = __webpack_require__(84878);
var Items_module_default = /*#__PURE__*/__webpack_require__.n(Items_module);
;// CONCATENATED MODULE: ./src/components/widgets/content/Content084/Items/Items.jsx






var Items = function(param) {
    var items = param.items;
    var activeTab = (0,Tabs_hooks/* useTabsState */.n)().activeTab;
    var filteredItems = (0,react.useMemo)(function() {
        return items.filter(function(param) {
            var title = param.title;
            return title === activeTab;
        });
    }, [
        activeTab,
        items
    ]);
    if (filteredItems.length < 1) {
        return null;
    }
    var _filteredItems = (0,_sliced_to_array/* default */.Z)(filteredItems, 1), item = _filteredItems[0];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (Items_module_default()).wrapper,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Paragraph */.nv, {
                className: (Items_module_default()).description,
                color: "grey",
                children: item.description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* ImageLite */.NH, {
                image: item.image,
                className: (Items_module_default()).image
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/widgets/content/Content084/Items/index.js


;// CONCATENATED MODULE: ./src/components/widgets/content/Content084/Content084.jsx







var Content084 = function(param) {
    var payload = param.payload;
    var ref;
    var title = (ref = payload === null || payload === void 0 ? void 0 : payload.title) !== null && ref !== void 0 ? ref : "";
    var items = (0,react.useMemo)(function() {
        var ref;
        return (ref = payload === null || payload === void 0 ? void 0 : payload.sphereList) !== null && ref !== void 0 ? ref : [];
    }, [
        payload === null || payload === void 0 ? void 0 : payload.sphereList
    ]);
    var extractedTabs = (0,react.useMemo)(function() {
        return (0,_to_consumable_array/* default */.Z)(new Set(items.map(function(item) {
            return item.title;
        })));
    }, [
        items
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (Content084_module_default()).wrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Container */.W2, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Content084_module_default()).block,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Heading3 */.aC, {
                        className: (Content084_module_default()).title,
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tabs_Provider/* TabsProvider */.X, {
                        items: extractedTabs,
                        tabsEnabled: true,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Tabs */.mQ, {
                                appearance: "justify",
                                className: (Content084_module_default()).tabs
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Items, {
                                items: items
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var Content084_Content084 = (Content084);


/***/ }),

/***/ 66406:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Content084_wrapper__xz_hd","block":"Content084_block__g6yPr","tabs":"Content084_tabs__o2nFD","title":"Content084_title__Y_ezT"};

/***/ }),

/***/ 84878:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Items_wrapper__Be3gm","description":"Items_description__Iu83z","image":"Items_image___j0eG"};

/***/ })

}]);